import Cookies from "js-cookie";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";

//internal import
import SignInService from "../services/SignInService";
import { notifySuccess, notifyError } from "../utils/toast";

const useLoginSubmit = () => {
  // const reduxDispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [loginData, setloginData] = useState([]);
  const [otpVerification, setotpVerification] = useState("start");
  const [adminID, setAdminID] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = ({ email, verifyEmail, password, otp }) => {
    setLoading(true);
    const cookieTimeOut = 0.5;

    if (location.pathname === "/client-login") {
      // reduxDispatch(removeSetting("globalSetting"));
      if (otpVerification === "start") {

        SignInService.clientLogin({ username: email, password: password })
          .then((res) => {
            if (res) {
              // var role = res?.role;
              // if (role === "Admin") {
              // localStorage.id = res?._id;
              localStorage.logOutPage = "1";
              setLoading(false);
              notifySuccess("Login Success!");
              var roleID = res.roleId;
              if (roleID !== "" && typeof roleID !== 'undefined') {
                Cookies.set("roleID", roleID);
              }
              // dispatch({ type: "USER_LOGIN", payload: res }); 
              Cookies.set("adminInfo", JSON.stringify(res), {
                expires: cookieTimeOut,
                sameSite: "None",
                secure: true,
              });
              navigate("/client-ticket-view");

              // } else {
              //   setloginData(res);
              //   setotpVerification("gototp");
              //   setAdminID(res.adminId);
              //   localStorage.id = res?._id;
              //   notifySuccess("Please Check Your Mail For Two Factor Authentication Code");
              //   setLoading(false);
              // }
            }
          })
          .catch((err) => {
            notifyError(err?.response?.data?.message || err?.message);
            setLoading(false);
          });
      }
    }
    else if (location.pathname === "/super-login") {
      // reduxDispatch(removeSetting("globalSetting"));
        SignInService.superAdminLogin({ email: email, password: password, role:"Super Admin"  })
          .then((res) => {
            if (res) {
              var role = res?.role;
              if(res.success || res.role === "Super Admin"){
                localStorage.id = res?._id;
                localStorage.logOutPage = "1";
                setLoading(false);
                notifySuccess("Login Success!");
                var roleID = res.roleId;
                if (roleID !== "" && typeof roleID !== 'undefined') {
                  Cookies.set("roleID", roleID);
                }
                // dispatch({ type: "USER_LOGIN", payload: res }); 
                Cookies.set("adminInfo", JSON.stringify(res), {
                  expires: cookieTimeOut,
                  sameSite: "None",
                  secure: true,
                });
                navigate("/stores");
              }
              else{
                notifyError(res.message);
              }

            }
          })
          .catch((err) => {
            notifyError(err?.response?.data?.message || err?.message);
            setLoading(false);
          });
    }
    else if (location.pathname === "/sign-in" || location.pathname === "/sign-in/") {
      // reduxDispatch(removeSetting("globalSetting"));
      if (otpVerification === "start") {

        SignInService.adminLogin({ username: email, password: password })
          .then((res) => {
            if (res) {
              var role = res?.role;
              if (role === "Admin") {
                localStorage.id = res?._id;
                localStorage.logOutPage = "1";
                setLoading(false);
                notifySuccess("Login Success!");
                var roleID = res.roleId;
                if (roleID !== "" && typeof roleID !== 'undefined') {
                  Cookies.set("roleID", roleID);
                }
                // dispatch({ type: "USER_LOGIN", payload: res }); 
                Cookies.set("adminInfo", JSON.stringify(res), {
                  expires: cookieTimeOut,
                  sameSite: "None",
                  secure: true,
                });
                navigate("/");

              } else {
                setloginData(res);
                setotpVerification("gototp");
                setAdminID(res.adminId);
                localStorage.id = res?._id;
                notifySuccess("Please Check Your Mail For Two Factor Authentication Code");
                setLoading(false);
              }
            }
          })
          .catch((err) => {
            notifyError(err?.response?.data?.message || err?.message);
            setLoading(false);
          });
      } else if (otpVerification === "gototp") {
        SignInService.verifyLoginAdmin({ adminId: adminID, code: otp })
          .then((res) => {
            localStorage.logOutPage = "1";
            setLoading(false);
            notifySuccess("Login Success!");
            var roleID = res.roleId;
            if (roleID !== "" && typeof roleID !== 'undefined') {
              Cookies.set("roleID", roleID);
            }
            // dispatch({ type: "USER_LOGIN", payload: res }); 
            Cookies.set("adminInfo", JSON.stringify(res), {
              expires: cookieTimeOut,
              sameSite: "None",
              secure: true,
            });
            navigate("/");
          })
          .catch((err) => {
            notifyError(err?.response?.data?.message || err?.message);
            setLoading(false);
          });
      }
    }

    if (location.pathname === "/forgot-password") {
      SignInService.forgetPassword({ verifyEmail })
        .then((res) => {
          setLoading(false);
          notifySuccess(res.message);
        })
        .catch((err) => {
          setLoading(false);
          notifyError(err?.response?.data?.message || err?.message);
        });
    }
  };

  const resendOTP = async () => {
    const res = await SignInService.adminResendOtp({ "adminId": adminID });
    if (res.success === true)
      notifySuccess(res.message);
    else
      notifyError(res.message);
  }
  return {
    onSubmit,
    register,
    handleSubmit,
    errors,
    loading,
    otpVerification,
    setotpVerification,
    adminID,
    resendOTP,
    loginData,
    setloginData
  };
};

export default useLoginSubmit;
